export default function About() {
  return (
    <section
      id="about"
      className="border-b border-[#0A0A0A] bg-gradient-to-b from-[#F5F3FF] to-[#EDE9FE] text-[#0A0A0A] scroll-mt-16"
      data-testid="about-section"
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-24 md:py-32 grid grid-cols-12 gap-y-14 md:gap-x-16 items-center">
        {/* Photo with purple accent frame */}
        <div className="col-span-12 lg:col-span-5">
          <p className="label-mono text-[#4C1D95] mb-6">/ 04 — About</p>
          <div className="relative max-w-[380px] mx-auto lg:mx-0">
            <div
              className="absolute inset-0 translate-x-4 translate-y-4 border-2 border-[#4C1D95]"
              aria-hidden="true"
            />
            <figure
              className="relative aspect-[3/4] overflow-hidden border border-[#0A0A0A] bg-white"
              data-testid="about-photo"
            >
              <img
                src="/images/parastou.webp"
                alt="Parastou Saba"
                loading="lazy"
                className="w-full h-full object-cover object-center"
              />
            </figure>
          </div>
        </div>

        {/* Statement */}
        <div className="col-span-12 lg:col-span-7 flex flex-col justify-center">
          <p className="label-mono text-[#595959] mb-4">Meet the founder</p>
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter mb-5">
            Hi — I&apos;m Parastou.
          </h2>
          <p className="mb-8">
            <span className="inline bg-[#EAEAEA] box-decoration-clone px-1.5 py-1 label-mono text-[#0A0A0A]">
              UX designer for complex, high-trust products
            </span>
          </p>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[#3F3F46] max-w-2xl">
            <p>
              I help founders take products that have{" "}
              <strong className="font-semibold text-[#0A0A0A]">
                grown complicated
              </strong>{" "}
              and make them{" "}
              <strong className="font-semibold text-[#0A0A0A]">
                feel obvious
              </strong>{" "}
              — the flows, the permissions, the error states, the parts nobody
              got around to designing.
            </p>
            <p>
              I work best on products that already exist and have grown tangled,
              not blank canvases. After years inside scientific instrument
              software, fintech, and multi-sided platforms, the work usually
              comes down to four things:
            </p>
            <ul className="space-y-3">
              {[
                "Mapping how roles, data, and money actually move",
                "Onboarding that gets people to their first real result",
                "Error states, empty states, and permission logic",
                "Design systems that hold up after I'm gone",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span
                    className="w-1.5 h-1.5 bg-[#0A0A0A] shrink-0 mt-3"
                    aria-hidden="true"
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p>
              I&apos;ve worked on{" "}
              <strong className="font-semibold text-[#0A0A0A]">
                100+ products
              </strong>{" "}
              across fintech, scientific software, health, and insurance — and
              I&apos;m direct about what I find. If your onboarding is leaking
              users, I&apos;ll tell you where and why rather than soften it into
              a deck nobody reads.
            </p>
            <p className="italic text-xl md:text-2xl text-[#0A0A0A]">
              Bring me the tangled one.
            </p>
          </div>

          <a
            href="#process"
            className="mt-10 self-start inline-flex items-center gap-3 bg-[#4C1D95] text-[#FFFFFF] px-7 py-4 label-mono border border-[#4C1D95] hover:bg-[#0A0A0A] hover:border-[#0A0A0A] transition-colors"
            data-testid="about-see-process"
          >
            See how I work
          </a>
        </div>
      </div>
    </section>
  );
}
